import React from "react";
import { Modal } from "react-bootstrap";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import { Typography } from "@mui/material";

const DesactivePartenaireModal = ({
  show,
  handleClose,
  handleDesactiveConfirm,
  parteanire,
}) => {
  if (!parteanire) {
    return null;
  }
  const { intitule } = parteanire;
  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton sx={{ borderBottom: "none", pb: 0 }}>
        <Typography variant="h5" component="h2" sx={{ fontWeight: 600 }}>
          Desactive <span className=" text-success ">{intitule}</span>
        </Typography>
      </Modal.Header>

      <Modal.Body>
        <Typography variant="body1" sx={{ mt: 2 }}>
          En desactivant {intitule}, vous prenez conscience que tous les agents
          associés seront désactivés.
        </Typography>
      </Modal.Body>

      <Modal.Footer sx={{ borderTop: "none", pt: 0 }}>
        <button
          className="btn btn-secondary"
          onClick={() => {
            handleClose();
          }}
        >
          Cancel
        </button>
        <button
          className="btn btn-danger"
          onClick={() => {
            handleDesactiveConfirm();
            handleClose();
          }}
        >
          Activer/Desactiver
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DesactivePartenaireModal;
